import script from "./VolunteerInvitationPreferences.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerInvitationPreferences.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerInvitationPreferences.vue?vue&type=style&index=0&id=c37c58bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c37c58bc"]])

export default __exports__